import { render, staticRenderFns } from "./Vol03.vue?vue&type=template&id=bed0eca4&scoped=true&"
import script from "./Vol03.vue?vue&type=script&lang=js&"
export * from "./Vol03.vue?vue&type=script&lang=js&"
import style0 from "./Vol03.vue?vue&type=style&index=0&id=bed0eca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed0eca4",
  null
  
)

export default component.exports